var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showAlert
    ? _c(
        _setup.BaseAlert,
        {
          class: _vm.classNames,
          attrs: { color: "text-secondary", "data-qa": "review_card_alert" },
        },
        [
          _vm.rate.is_hidden_for_verification
            ? [
                _vm._v(
                  "\n    " +
                    _vm._s(_setup.hiddenPrefix) +
                    ".\n    " +
                    _vm._s(_setup.tStatic("Если вы автор, напишите нам")) +
                    "\n    "
                ),
                _c("a", { attrs: { href: "mailto:proverka@medrocket.ru" } }, [
                  _vm._v("proverka@medrocket.ru"),
                ]),
                _vm._v(
                  "\n    " + _vm._s(_setup.tStatic("или позвоните")) + "\n    "
                ),
                _c(
                  "a",
                  {
                    staticClass: "text-no-wrap",
                    attrs: { href: "tel:+78006003028" },
                  },
                  [_vm._v("8 (800) 600-30-28")]
                ),
                _vm._v(".\n  "),
              ]
            : _vm.rate.is_deleted
            ? [
                _vm._v(
                  "\n    " +
                    _vm._s(_setup.tStatic("Отзыв удалён автором")) +
                    "\n    "
                ),
                _setup.deletedDate
                  ? [_vm._v("\n      " + _vm._s(_setup.deletedDate) + "\n    ")]
                  : _vm._e(),
              ]
            : _vm.rate.is_refuted
            ? [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _setup.refutationText /* eslint-disable-line vue/no-v-html */
                    ),
                  },
                }),
              ]
            : [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _setup.tStatic(
                        "Отзывы от неавторизованных пользователей не участвуют в рейтинге"
                      )
                    ) +
                    "\n  "
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }